import { useTranslation } from 'react-i18next'
import { KeyValueTable } from '@/features/admin/components/KeyValueTable'

export const BusinessDetailsTableLayout: React.FC<
    Record<'businessName' | 'description', React.ReactNode>
> = ({ businessName, description }) => {
    const { t } = useTranslation()

    return (
        <KeyValueTable
            rows={[
                {
                    label: t('business.name'),
                    value: businessName,
                },
                {
                    label: t('common.description'),
                    value: description,
                },
            ]}
        />
    )
}
